import { lowerWaveWithStatusLessThanApproved } from './lowerWaveWithStatusLessThanApproved';
import { Line, Model } from '../state/model';

export function isNotLocked({ model }: Line & { model: Model & { relatedModels: Model[] } }) {
  return model.status === 'Planning' && !lowerWaveWithStatusLessThanApproved(model.relatedModels, model);
}
